import React from 'react'
import GoogleMap from '../shared/GoogleMap'
import ExternalLink from '../shared/ExternalLink'

import styles from './Location.module.css'

const config = {
  coordinates: {
    lat: 48.347600,
    lng:  9.303366,
  },
  url: 'https://goo.gl/maps/df77VN5rTniYiYfT7',
  googleMapURL:  'https://maps.googleapis.com/maps/api/js?key=AIzaSyBLLoMmrP3YEScTuoPUZ17gMcPYPPXt2ec', // TODO
}

const Location = () => {
  return (
    <div className={styles.location}>
      <ExternalLink url={config.url}>
        <GoogleMap
          center={config.coordinates}
          googleMapURL={config.googleMapURL}
          loadingElement={
            <div style={{ height: '100%', width: '100%' }}>Loading ..</div>
          }
          containerElement={<div style={{ height: '210px' }} />}
          mapElement={<div style={{ height: '100%' }} />}
        />
      </ExternalLink>
    </div>
  )
}

export default Location



// WEBPACK FOOTER //
// ./src/components/contact/Location.js